import { SUMMARY_CLASSES } from '../constants/classNames';

export default function ReactionSummary({ reaction }) {
  const equation = reaction.getEquation();
  return (
    <div className={SUMMARY_CLASSES.root}>
      {equation && <p className={SUMMARY_CLASSES.equation}>{equation}</p>}
      <p className={SUMMARY_CLASSES.product}>
        {reaction.hasVisibleReaction() ? 'You made: ' : 'Result: '}
        <strong>{reaction.productName}</strong>
      </p>
      <p className={SUMMARY_CLASSES.conditions}>🧪 {reaction.conditions}</p>
    </div>
  );
}
